import React from "react";
import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
import { Button, Grid } from "@mui/material";
// import InvoiceListingTable from "./InvoiceListingTable";
// import CreateInvoiceNewList from "./CreateInvoiceNewList";
// import swal from "sweetalert";
// import { makeGetRequest } from "../../../utils/utils";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
// import CreateIcon from "@mui/icons-material/Create";
import SearchIcon from "@mui/icons-material/Search";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MicIcon from "@mui/icons-material/Mic";
import SortIcon from "@mui/icons-material/Sort";

function InvoiceListingNew() {
  const navigate = useNavigate();

  // For memu
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (status) => {
    alert(status);
    setAnchorEl(null);
  };
  // End

  // async function InvoiceAutoGeneration() {
  //   makeGetRequest("invoice/autoinvoice", "")
  //     .then((response) => {
  //       if (response.status == "201") {
  //         swal(
  //           "Auto Invoice Generation completed!",
  //           response.message,
  //           "success"
  //         );
  //       } else {
  //         swal("There was an error!", response.message, "warning");
  //       }
  //     })
  //     .catch((err) => {
  //       swal("There was an error!", "more error details", "warning");
  //     });
  // }

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Invoice Templates</h1>
            <Button
              className="primaryBtn"
              // onClick={() => navigate("/CreateInvoiceNew")}
              onClick={() => navigate("/CreateNewTemplate")}
            >
              Create New Template
            </Button>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              <div className="visitorListNewOut">
                <div className="visitorHead">Invoice Management </div>
                <div>
                  <div className="visitorListNewInner">
                    <div className="visitorSearch">
                      <div className="visitorSearchDiv">
                        <SearchIcon className="visitorSearchIco" />
                        <input type="text" placeholder="Search" />
                        <MicIcon className="visitorMicIco" />
                      </div>
                      <SortIcon
                        className="visitorFilterIco"
                        // aria-controls={open ? "basic-menu" : undefined}
                        // aria-haspopup="true"
                        // aria-expanded={open ? "true" : undefined}
                        onClick={handleClick}
                      />
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}
                      >
                        <MenuItem onClick={() => handleClose("true")}>
                          Paid Invoice
                        </MenuItem>
                        <MenuItem onClick={() => handleClose("false")}>
                          Unpaid Invoice
                        </MenuItem>
                      </Menu>
                    </div>

                    {/* KKK */}
                    <div className="visitContDiv paidInvoice invoiceTemplateOuter">
                      <div className="visitCont1">
                        <div className="visitContLeft">
                          {/* <h3 className="visitContHed"></h3> */}
                          <p className="visitContMob">
                            <span>Invoice Name :</span>
                            <b>Water Maintenance</b>
                          </p>
                          <p className="visitContMob">
                            <span>Note :</span>
                            <b>Lorem ipsum dummy text</b>
                          </p>
                        </div>
                        <div className="visitContRight">
                          <div className="visitBottCont billAmountNew">
                            <p>Created Date :</p>
                            <b>2023-06-29</b>
                          </div>
                        </div>
                      </div>
                      <div className="visitCont2">
                        <p className="visitContMob">
                          <span>Bill Amount :</span>
                          <b>
                            <CurrencyRupeeIcon />
                            1000
                          </b>
                        </p>
                        <p className="visitContMob">
                          <span>Late Fee :</span>
                          <b>
                            <CurrencyRupeeIcon /> 50
                          </b>
                        </p>
                        <p className="visitContMob">
                          <span>Total Due :</span>
                          <b>
                            <CurrencyRupeeIcon /> 1050
                          </b>
                        </p>

                        <div className="resideNewCont">
                          <Button
                            className="invoSendB"
                            onClick={() => navigate("/SendInvoiceTo")}
                          >
                            Send Invoice
                          </Button>
                        </div>
                      </div>
                    </div>

                    <div className="visitContDiv paidInvoice invoiceTemplateOuter">
                      <div className="visitCont1">
                        <div className="visitContLeft">
                          {/* <h3 className="visitContHed"></h3> */}
                          <p className="visitContMob">
                            <span>Invoice Name :</span>
                            <b>Water Maintenance</b>
                          </p>
                          <p className="visitContMob">
                            <span>Note :</span>
                            <b>Lorem ipsum dummy text</b>
                          </p>
                        </div>
                        <div className="visitContRight">
                          <div className="visitBottCont billAmountNew">
                            <p>Created Date :</p>
                            <b>2023-06-29</b>
                          </div>
                        </div>
                      </div>
                      <div className="visitCont2">
                        <p className="visitContMob">
                          <span>Bill Amount :</span>
                          <b>
                            <CurrencyRupeeIcon />
                            1000
                          </b>
                        </p>
                        <p className="visitContMob">
                          <span>Late Fee :</span>
                          <b>
                            <CurrencyRupeeIcon /> 50
                          </b>
                        </p>
                        <p className="visitContMob">
                          <span>Total Due :</span>
                          <b>
                            <CurrencyRupeeIcon /> 1050
                          </b>
                        </p>

                        <div className="resideNewCont">
                          <Button
                            className="invoSendB"
                            onClick={() => navigate("/SendInvoiceTo")}
                          >
                            Send Invoice
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default InvoiceListingNew;
